'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preloadHistory = undefined;

var _resolveThreadedChatAreaContainer = require('../code-splitting/resolvers/resolveThreadedChatAreaContainer');

var _resolveUnifiedThreadHistory = require('../code-splitting/resolvers/resolveUnifiedThreadHistory');

var _isUngatedForUTV = require('../gates/selectors/isUngatedForUTV');

var _once = require('../utils/once');

var resolveThreadedChatAreaContainerOnce = (0, _once.once)(_resolveThreadedChatAreaContainer.resolveThreadedChatAreaContainer);
var resolveUnifiedThreadHistoryOnce = (0, _once.once)(_resolveUnifiedThreadHistory.resolveUnifiedThreadHistory);

var preloadHistory = exports.preloadHistory = function preloadHistory() {
  return function (__dispatch, getState) {
    if ((0, _isUngatedForUTV.isUngatedForUTV)(getState())) {
      resolveUnifiedThreadHistoryOnce();
    } else {
      resolveThreadedChatAreaContainerOnce();
    }
  };
};